module.exports = __webpack_public_path__ + "img/dawaai-icon.622c5e5a.png";